// Start: Image with Text Carousell Functions

document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".carousel-slider");
  const slides = document.querySelectorAll(".carousel-slide");
  const prevBtn = document.querySelector(".carousel-prev");
  const nextBtn = document.querySelector(".carousel-next");

  let index = 0;
  const totalSlides = slides.length;

  function updateSlidePosition() {
    slider.style.transform = `translateX(-${index * 100}%)`;
  }

  nextBtn.addEventListener("click", () => {
    index = (index + 1) % totalSlides;
    updateSlidePosition();
  });

  prevBtn.addEventListener("click", () => {
    index = (index - 1 + totalSlides) % totalSlides;
    updateSlidePosition();
  });

  // Set initial position
  updateSlidePosition();
});


// End: Image with Text Carousell Functions